export default __webpack_public_path__ + "static/media/Heart.77b1891f.svg";